// Small inline icon set (stroke icons, 20px grid). Decorative unless given a label.
const PATHS: Record<string, string> = {
  heart: "M10 16.5s-6-3.6-6-8A3.5 3.5 0 0 1 10 6a3.5 3.5 0 0 1 6 2.5c0 4.4-6 8-6 8z",
  play: "M7 5l8 5-8 5z",
  pause: "M7 5v10M13 5v10",
  mail: "M3 5h14v10H3zM3 6l7 5 7-5",
  print: "M6 8V3h8v5M6 14H4V8h12v6h-2M6 12h8v5H6z",
  share: "M8 10.5l4-2.5M8 9.5l4 2.5M5.5 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM14.5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM14.5 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  spark: "M10 3v4M10 13v4M3 10h4M13 10h4M5.5 5.5l2 2M12.5 12.5l2 2M5.5 14.5l2-2M12.5 7.5l2-2",
  clock: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM10 6v4l3 2",
  back: "M12 5l-5 5 5 5",
  next: "M8 5l5 5-5 5",
  x: "M5 5l10 10M15 5L5 15",
  full: "M4 8V4h4M12 4h4v4M16 12v4h-4M8 16H4v-4",
  save: "M5 3h8l3 3v11H5zM7 3v5h6V3M7 17v-5h7v5",
  trash: "M4 6h12M8 6V4h4v2M6 6l1 11h6l1-11",
  copy: "M7 7h9v10H7zM4 13V3h9",
  check: "M4 10l4 4 8-8",
};

export function Icon({ name, size = 18, label }: { name: keyof typeof PATHS | string; size?: number; label?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round"
      aria-hidden={label ? undefined : true} role={label ? "img" : undefined} aria-label={label} className="icon">
      <path d={PATHS[name] ?? ""} fill={name === "play" ? "currentColor" : "none"} />
    </svg>
  );
}
